import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Container.module.scss';
import cn from 'classnames';
const Container = ({ children, className }) => {
    return _jsx("div", Object.assign({ className: cn(styles.element, className) }, { children: children }));
};
export default Container;
